import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import PrintButton from '../components/PrintButton';

function AuditLog({ user }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const data = await window.zignagenixAPI.getAuditLog(100);
        setEntries(data);
      } catch (err) {
        console.error('Failed to load audit log:', err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) return <div className="page-loading">Loading audit log...</div>;

  return (
    <div className="page">
      <div className="page-header-row">
        <div>
          <h1 className="page-title">Audit Log</h1>
          <p className="page-subtitle">HIPAA compliance access tracking</p>
        </div>
        <PrintButton pageTitle="Audit Log" subtitle="HIPAA Compliance Access Tracking" />
      </div>

      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>User</th>
              <th>Action</th>
              <th>Resource</th>
              <th>ID</th>
              <th>Details</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="mono">{e.timestamp}</td>
                <td>{e.user_name || '—'}</td>
                <td><span className={`action-badge action-badge--${e.action?.toLowerCase()}`}>{e.action}</span></td>
                <td>{e.resource_type}</td>
                <td className="mono">{e.resource_id || '—'}</td>
                <td>{e.details || '—'}</td>
                <td className="mono">{e.ip_address}</td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr><td colSpan="7" className="empty-state">No audit entries</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AuditLog;
